import { updateSession } from '../../lib/funnels/functions/v1/default/updateSession.js'
import { getFunnelCache } from '../../lib/funnels/functions/v1/default/getFunnelCache.js'
import { queryParamsToSession } from '../../lib/funnels/functions/v1/default/queryParamsToSession.js'

const SESSION_ID = 'atdsFunnel'
// funnel is served from the domain root in prod, but under /atds locally
const BASE_PATH = window.location.hostname.includes('local') ? '/atds' : ''

document.addEventListener('DOMContentLoaded', () => {
  queryParamsToSession(SESSION_ID)

  const params = new URLSearchParams(window.location.search)

  // 'df' variant copy, mirrors the Next.js router.query.df == 1 branch
  if (params.get('df') == '1') {
    document.getElementById('headline').textContent = 'Are You Eligible?'
    document.getElementById('question-text').innerHTML =
      'How much do you owe on <b>Credit Cards</b> or <b>Personal Loans</b>?'
  }

  document.querySelectorAll('[data-debt]').forEach((btn) => {
    const anchor = /** @type {HTMLAnchorElement} */ (btn)
    anchor.addEventListener('click', (e) => {
      e.preventDefault()
      updateSession(SESSION_ID, 'debtOwed', anchor.dataset.debt || '')
      window.location.href = `${BASE_PATH}${anchor.getAttribute('href')}${window.location.search}`
    })
  })

  // aff_id-conditional pixels
  // ASSUMPTION: queryParamsToSession stores raw query params (utm_campaign/aff_id) into
  // the session cache the same way dsa's does. Confirm this matches the shared lib's actual behavior.
  const sessData = getFunnelCache(SESSION_ID) || {}
  const affId =
    sessData.aff_id ||
    sessData.utm_campaign ||
    params.get('aff_id') ||
    params.get('utm_campaign') ||
    ''

  if (affId === '16' || affId === '942') {
    const pixelMap = {
      16: { id: '936236513645828', event: 'PageView' },
      942: { id: '825529772827507', event: 'Lead' },
    }
    const { id, event } = pixelMap[affId]
    const s = document.createElement('script')
    s.innerHTML = `!function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${id}');
      fbq('trackSingle','${id}', '${event}');`
    document.body.appendChild(s)
  }

  if (affId === '776') {
    const s = document.createElement('script')
    s.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-KWDN5Q8');`
    document.body.appendChild(s)
  }
})
